import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import {toast} from "react-toastify";

const ChequePicked = ({
  getChequePickedList = null,
  chequePickedList = null,
  match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [dispatchData, setDispatchData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [closed, setClosed] = useState(false);
  const handleModalHide = () => {
    setIsModal(false);
    window.location.reload();
  }

  const Headers = [
    'Meeting Ref. No.',
    'Site No.',
    'Business',
    'Agenda',
    'Invoice No.',
    'Bank',
    'Transaction/Cheque No.',
    'Transaction/Cheque Amount',
    'TDS Amount',
    'Transaction Date',
    'Attachment',
    'Created At',
    'Created By',
    'Status',
    'Dispatch',
  ];
  //console.log('PAGE::CHEQUE PICKED ' + JSON.stringify(chequePickedList));
  useEffect(() => {
    if (getChequePickedList !== null)
      (async () => {
        setIsLoading(true);
        await getChequePickedList(1);
        setIsLoading(false);
      })();
  }, [getChequePickedList]);


  useEffect(() => {
    const tableData = [
        'id',
        'meeting_reference_no',
        'site_no',
        'business_name',
        'agenda',
        'invoice_no',
        'bank',
        'trnx_no',
        'trnx_amt',
        'tds_amount',
        'trnx_date',
        'attachment',
        'created_at',
        'created_by',
        'status',
        'Dispatch',
    ];
    if (chequePickedList && chequePickedList.data) {
    const data = chequePickedList.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => (
            key === 'attachment' && (element['attachment'].split('.').pop() === 'jpeg' || element['attachment'].split('.').pop() === 'jpg' || element['attachment'].split('.').pop() === 'png') ?
            {
                [key]: <a href={element['attachment']} target="_blank"><img src={element['attachment']}
                                                                            style={{
                                                                                "width": "48px",
                                                                                "borderRadius": "16px",
                                                                                "height": "48px"
                                                                            }}/></a>
            } :
            key === 'document' && element['attachment'].split('.').pop() === 'doc' ? {
                    [key]: <a href={element['attachment']} target="_blank"><img src={Images?.DocIcon}
                                                                                alt=""
                                                                                className="view-icon"/></a>
                } :
                key === 'document' && element['attachment'].split('.').pop() === 'pdf' ? {
                        [key]: <a href={element['attachment']} target="_blank"><img src={Images?.DocIcon}
                                                                                    alt=""
                                                                                    className="view-icon"/></a>
            }: 
            key === 'Dispatch' && (element['status'] === 'Completed') ? {[key]: 'No'} : { [key]: element[key] })),
        //   {
        //     Action:
              
        //       [
        //         {
        //           name: 'Dispatch',
        //           link: `${baseUrl}/brand-activation/dispatch`,
        //         }
        //       ]
        //   }
        )
      );
      //console.log(data);
      if(data){
        setListData(data);
      }else{
        setListData([]);   
      }
    
   
    setPageCount(Math.ceil(chequePickedList.total / chequePickedList.per_page));
  }
  }, [chequePickedList]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getChequePickedList(val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {return null}

//   const headerBtns = () => {
//     return (
//       <Fragment>
//         <Link
//           to={`${baseUrl}/brand-activation/view-cheque-picked`}
//           className="btn btn-primary d-md-inline-block"
//         >
//           {localization.chequePickedView}
//           <img src={Images?.ArrowRight} alt="" />
//         </Link>const headerBtns = () => {
//         <Link
//           to={`${baseUrl}/brand-activation/schedule-new-meeting`}
//           className="btn btn-primary d-md-inline-block"
//         >
//           {localization.addMeeting}
//           <img src={Images?.ArrowRight} alt="" />
//         </Link>
//         <Button
//         onClick={filterToggle}
//         className="filter-hamburger btn btn-transparent"
//       >
//         <img src={Images.Filter} alt="" />
//         {localization.showFilters}
//       </Button>
//       </Fragment>
//     );
//   };

  useEffect(() => {
    if (closed === true){
        toast.success('Dispatched Successfully');
        setTimeout(function() {
          window.location.reload();
        },3000);
    }
  },[closed]);
  
  const disPatchCheque =  async (data) => { 
    console.log(data);
    setDispatchData(data);
    setIsModal(true);
  }  

  const handleContinue = async () => {
    setIsModal(false);
    if (dispatchData.action === 'dispatch') {
      const payload = {
        id: dispatchData.dispatchObj.id,
        remarks: remark,
        actionFor: 'Dispatch',
        status: 'Completed'
      }; 
      setIsLoading(true);
      (async() => {       
        const url = `${Config.brandActivation.dispatchCheque}`;   
        const { data } = await axios.post(url,payload);
        const res = data?.response?.status;
          if(res === true) {
            setIsLoading(false);
            setIsModal(false);
            setClosed(true);
          } else {
            setIsLoading(false);
            if(data?.message){
              toast.error(data?.message);
            }else{
              toast.error('Not dispatched.');
            }
            
          }
       })();
      } else {
      setIsModal(false);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to="/dashboard/brand-activation/view-cheque-picked" onClick={func} className="btn btn-transparent">
          {localization.returnToIncentive}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };  
  console.log(dispatchData?.action);
  return (
    <Layout
        title={localization.pickedCheque}
        Buttons={headerBtns}
        isGoback
        isLoading={isLoading}
        linkUrl={`${baseUrl}/brand-activation/scheduled-meeting`}
    >
    <TableSection
        data={listData}
        isId={false}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        onChange={(data) => {disPatchCheque(data)}}
        srNo={chequePickedList?.from}
    />
    <ModalPop
          title={
          dispatchData && dispatchData.action === 'dispatch'
              ? localization.dispatchConf
              : 'N/A'
          }
          show={isModal}
          handleModalHide={handleModalHide}
          dispatchData={dispatchData}
      >
      {dispatchData && dispatchData.action === 'dispatch' ? (
      <Fragment>
          <div className="modal-body">
          <div className="text-center">
              <h5>{localization.dispatchCheque}</h5>
              <div className="form-group">
              <ConstantInput
                  label={localization.addRemark}
                  required
                  //isStarRequired={true}
                  type="text"
                  handleChange={(val) => {
                   setRemark(val);
                  }}
              />
              </div>
              <Button
              className="btn btn-primary"
              onClick={handleContinue}
              >
              {localization.continue}{' '}
              <img src="../images/arrow-right.png" alt="" />
              </Button>
          </div>
          </div>
      </Fragment>
      ) : (
      <Fragment>
          {successIconBox(localization.dispatchSuccess, handleModalHide)}
      </Fragment>
      )}
      </ModalPop>
    </Layout>
  );
};

ChequePicked.propTypes = {
  chequePickedList: PropTypes.any,
  getChequePickedList: PropTypes.func,
  match: PropTypes.any,
};

export default ChequePicked;
